module.exports = __webpack_public_path__ + "img/bgWorkApplication.210847ac.png";